import {
  SET_TRIALTAG,
  TrialTagActionTypes,
  TrialTagState,
  TrialTag,
  TrialTagById,
} from '../types';

const initialState: TrialTagState = {
  allIds: undefined,
  byId: undefined,
};

function setNormalizedTrialTag(
  state: TrialTagState, trialTagList: TrialTag[],
): TrialTagState {
  const allIds: number[] = [];
  const byId = trialTagList.reduce((accumulator, current) => {
    accumulator[current.tagId] = current;
    allIds.push(current.tagId);
    return accumulator;
  }, {} as TrialTagById);
  return {
    ...state,
    byId,
    allIds,
  };
}

function InstituteReducer(state = initialState, action: TrialTagActionTypes): TrialTagState {
  switch (action.type) {
    case SET_TRIALTAG:
      return setNormalizedTrialTag(state, action.payload);
    default:
      return state;
  }
}

export default InstituteReducer;
